export default "__VITE_ASSET__AJZZ9Crt__"